module.exports = __webpack_public_path__ + "svg/illustration-seller.fb96de4.svg";